export default __webpack_public_path__ + "img/a95d18a7baf6e3ac5b4b292c2016b0f1.svg";